   console.log('DSi_basico.js'); 

   import axios from "axios";
   import * as XLSX from "xlsx";
   import html2canvas from 'html2canvas';
   import jsPDF from 'jspdf';



    var url =  sessionStorage['url']

    var mobile = ismobile()


    function ismobile(){

        if (window.innerWidth < 600){
            mobile = true;
            return true
        }else{
            mobile = false;
            return false
        }
    };

    function maps(item){
        let link = 'https://www.google.com/maps/search/'+item
        window.open(link, '_blank');      
    };

    export function send_whats(cel,nome,ide, msg_enivar){

        console.log('mobile:');
        console.log(mobile);

        nome = nome.toLowerCase().trim();  //passo tudo pra minuscula

        cel = cel.replace(/[^\d]+/g,'');
        
        //  4499685172
        if (cel?.length > 10){
            // cel = cel?.substring(0,2) + cel?.substring(3,20);//deixo de fora o 1º 9
        }
        

        nome = nome.split(" ");//separo as palavras
        nome = nome[0];//pego o primeiro nome        
        nome = nome.charAt(0).toUpperCase() + nome.slice(1);//passo 1 letra maiuscula
        // alert(nome);

        let quebra = '%0A'
        let msg = ''

        if (!msg_enivar){
            msg =  "Olá%20" + nome 

            if (ide){
                msg = ide+ quebra + "Olá%20" + nome 
            }
    
        }
        else{
            msg = msg_enivar
        }
        



        if (msg !==''){
            if (mobile){
            window.open("https://api.whatsapp.com/send?phone=55"+ cel +'&text='+ msg);
            }else{
            window.open("https://web.whatsapp.com/send?phone=55"+ cel +'&text='+ msg);
            }
            // https://wa.me/
        }

    };

    export  async function primeiro_nome(nome){

       //primeira maiuscula 
        nome = nome.toLowerCase().trim();  //passo tudo pra minuscula
        nome = nome.split(" ");//separo as palavras
        nome = nome[0];//pego o primeiro nome        
        nome = nome.charAt(0).toUpperCase() + nome.slice(1);//passo 1 letra maiuscula


        return nome
    };



    function moeda(event) {
        
        var v = (event && event.target) ? event.target.value : event
        // console.log(v);
        
        
        // Permite apenas números e o sinal de menos no início
        v = v.replace(/[^0-9,-]/g, "");
        
        // Garante que o sinal de menos só apareça no início
        v = v.replace(/(,)|(-)(?=.*-)/g, "");
        
        // Reaplica o sinal de menos se necessário
        let isNegative = v.startsWith("-");
        v = v.replace(/\D/g, ""); // Remove qualquer caractere não numérico
        
        v = v.replace(/[0-9]{12}/, "inválido"); // Limita para máximo 999.999.999,99
        v = v.replace(/(\d{1})(\d{8})$/, "$1.$2"); // Coloca ponto antes dos últimos 8 dígitos
        v = v.replace(/(\d{1})(\d{5})$/, "$1.$2"); // Coloca ponto antes dos últimos 5 dígitos
        v = v.replace(/(\d{1})(\d{1,2})$/, "$1,$2"); // Coloca vírgula antes dos últimos 2 dígitos
        
        // Retorna o valor com o sinal negativo se necessário
        // console.log(v);
        return isNegative ? "-" + v : v;
    };
  
    function moedaOLD(event){
        // console.log(event.target.value);

        var v = event.target.value;//captura o valor do event

        v=v.replace(/\D/g,"") //permite digitar apenas números
        v=v.replace(/[0-9]{12}/,"inválido") //limita pra máximo 999.999.999,99
        v=v.replace(/(\d{1})(\d{8})$/,"$1.$2") //coloca ponto antes dos últimos 8 digitos
        v=v.replace(/(\d{1})(\d{5})$/,"$1.$2") //coloca ponto antes dos últimos 5 digitos
        v=v.replace(/(\d{1})(\d{1,2})$/,"$1,$2") //coloca virgula antes dos últimos 2 digitos

        // event.target.value = v;
        return v;  
    };



    function allUpper(event){
        let a = event;//captura o valor do event
        if ((a!=='')&&(a!=null)){  
            a = a.toUpperCase();
            return a;
        } 
        else{
            return ''
        }
    };



    function firstUpper(event){
        let a = event;//captura o valor do event

        if (a!=='' && a.length==1){  
          a = a.toUpperCase();
        } 
        return a
    };


    export function get_data_hora(tipo){

        let retorno = {}

        var now = new Date();
        let mes_atual = now.getFullYear() +'-'+ (("0" + (now.getMonth() + 1)).slice(-2))
        let mes_seguinte = now.getMonth()+1
        if (mes_seguinte==12){
            mes_seguinte = (now.getFullYear()+1) +'-01'
        }
        else{
            mes_seguinte = now.getFullYear() +'-'+ (("0" + (now.getMonth() + 2)).slice(-2))
        }

        retorno.mes_seguinte = mes_seguinte;


        let a = new Date().toLocaleDateString('pt-Br',{ datestyle: 'short', hour12: false, timeZone: 'America/Sao_Paulo' });  
        retorno.hoje = a;


        a = retorno.hoje.slice(6, 10) +'-'+ retorno.hoje.slice(3, 5) +'-'+ retorno.hoje.slice(0, 2) ; //formato us yyyy-mm-dd
        let hora = new Date().toLocaleTimeString('pt-Br',{ hour12: false, timeZone: 'America/Sao_Paulo' });

        retorno.today        = a
        retorno.hora         = hora //hora agora
        retorno.data_hora    = retorno.hoje+'_'+hora 

        retorno.quinze_dias  = incDay(retorno.today, 15,'us')
        retorno.trinta_dias  = incDay(retorno.today, 30,'us')
        retorno.um_ano       = incDay(retorno.today, 365,'us')
        retorno.ano_atual    = now.getFullYear()
        retorno.ano_seguinte = now.getFullYear() + 1;
        retorno.mes_inicio   = now.getFullYear() +'-'+ (("0" + (now.getMonth() + 1)).slice(-2) + '-01')
        retorno.mes_fim      = now.getFullYear() + '-' + ("0" + (now.getMonth() + 1)).slice(-2) + '-' + new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();

        retorno.dia_semana   = now.toLocaleDateString('pt-BR', {
                                        day: 'numeric',   // "16"
                                    weekday: 'long', // "segunda-feira"
                                    });


        retorno.ano_seguinte_inicio   = now.getFullYear() + 1 + '-01-01';
        retorno.mes_seguinte_inicio   = now.getFullYear() +'-'+ (("0" + (now.getMonth() + 1)).slice(-2) + '-01')

        // console.log('today:', retorno[tipo]);
        
        // ir acrescentando conforme demanda!
        return retorno[tipo]
        

    };

    export function define_data_hora(that){
        //passo o comando this la e recebo aqui o that
        // console.log('that:');
        // console.log(that);


        var now = new Date();
        let mes_atual = now.getFullYear() +'-'+ (("0" + (now.getMonth() + 1)).slice(-2))
        let mes_seguinte = now.getMonth()+1
        if (mes_seguinte==12){
            mes_seguinte = (now.getFullYear()+1) +'-01'
        }
        else{
            mes_seguinte = now.getFullYear() +'-'+ (("0" + (now.getMonth() + 2)).slice(-2))
        }

        try{
            that.mes_atual    =  mes_atual
            that.mes_seguinte = mes_seguinte
        }
        finally {}



        // console.log('mes_atual:', mes_atual);
        // console.log('mes_seguinte:', mes_seguinte);
        // let mes_atual = now.getMonth()+1

        

        //data longa 20 de abrthatil de 2022
        let b = new Date().toLocaleDateString('pt-Br',{ datestyle: 'short',hour12: false, timeZone: 'America/Sao_Paulo' ,  weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'}); 
        that.hoje_week = b
        

        // console.log('update_values');
        let a = new Date().toLocaleDateString('pt-Br',{ datestyle: 'short', hour12: false, timeZone: 'America/Sao_Paulo' });  
        // console.log('hoje = '+ a);
        that.hoje = a;

        //dia numerico do mes
        that.dia_hoje  = that.hoje.slice(0, 2)

        // a = new Date().toLocaleTimeString('pt-Br',{ timeStyle: 'short', hour12: false, timeZone: 'America/Sao_Paulo' });
        a = new Date().toLocaleTimeString('pt-Br',{ hour12: false, timeZone: 'America/Sao_Paulo' });
        // console.log('hora = '+ a);
        that.hora = a;

        a = that.hoje + '_'+ that.hora;
        // console.log('data_hora = '+ a);
        that.data_hora = a;


        a = that.hoje.slice(6, 10) +'-'+ that.hoje.slice(3, 5) +'-'+ that.hoje.slice(0, 2) ; //formato us yyyy-mm-dd
        // console.log('today = '+ a);
        that.today = a;
        let today = a

        a = that.data_hora+'_' +sessionStorage['lg:USUARIO']
        // console.log('alterou = '+ a);
        that.quem_alterou = a;


        let yesterday = incDay(today, -1,'us')
        that.yesterday = yesterday

        let tomorrow = incDay(today, 1,'us')
        that.tomorrow = tomorrow
        // alert(yesterday)

    };

    export function get_quem_alterou(){
      let data = new Date().toLocaleDateString('pt-Br',{ datestyle: 'short', hour12: false, timeZone: 'America/Sao_Paulo' });  

      let hora = new Date().toLocaleTimeString('pt-Br',{ hour12: false, timeZone: 'America/Sao_Paulo' });
    
      let data_hora = data + '_'+ hora;
      
      let user = sessionStorage['lg:USUARIO']
    
      let r  = data_hora+'_'+user
      return r
    };

    



    function incDay(data,dias,pt){
        let a = new Date(data+' 00:00:00')//sempre que criar data definir horario
        a.setDate(a.getDate() + dias)//adiciono dias na data


        let r = new Date(a).toLocaleDateString('pt-Br',{ datestyle: 'short', hour12: false, timeZone: 'America/Sao_Paulo' });//formato dd/mm/yyyy 
        // alert('r:'+ a)
        // alert('r:'+ r)

        if (pt='us'){
            let today = r.slice(6, 10) +'-'+ r.slice(3, 5) +'-'+ r.slice(0, 2) ; //formato us yyyy-mm-dd
            return today
            
        }else if (pt='pt'){
            return r
        }
    };

    function incMonth(data,meses,pt){
        let a = new Date(data+' 00:00:00')//sempre que criar data definir horario
    
        //Adicionar meses 
        a = a.setMonth(a.getMonth()+meses);
        let r = new Date(a).toLocaleDateString('pt-Br',{ datestyle: 'short', hour12: false, timeZone: 'America/Sao_Paulo' });//formato dd/mm/yyyy 
        if (pt='us'){
            let today = r.slice(6, 10) +'-'+ r.slice(3, 5) +'-'+ r.slice(0, 2) ; //formato us yyyy-mm-dd
            return today
            
        }else if (pt='pt'){
            return r
        }
    };

    // function strtofloat(vem){
    //     if (vem){
    //         vem = vem.replaceAll('.','');
    //         vem = vem.replaceAll(',','.');
    //     }

    //     return vem
    // };

export function strtofloat(valor) {
  if (valor === null || valor === undefined) return 0;

  let v = String(valor);

  // equivalente ao: if pos(',', valor) > 0
  if (v.indexOf(',') !== -1) {
    // formato BR: 1.239,90
    v = v.replace(/\./g, '').replace(',', '.');
  }

  return parseFloat(v) || 0;
}


    export function floatTostring(vem){
        // alert(vem)
        let A = ''
        if (vem){
            A = vem.toLocaleString('pt-br',{ minimumFractionDigits: 2, maximumFractionDigits: 2 });
            // alert(A)

            // Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(total_juros);
            // A = A.replaceAll('.','');
            // A = A.replaceAll('.',',');
        }

        return A
    };

    export function floatTostring2(vem){
        // alert(vem)
        let A = ''
        if (vem){
            A = vem.toLocaleString('pt-br',{ minimumFractionDigits: 2, maximumFractionDigits: 2 });
            A = A.replaceAll('.',',');
        }
    
        return A
    };

    function getFormatDate(data){
        if (data?.length >2 ){
        let dia =   data.substring(8,10) + '/'+ data.substring(5,7)+ '/'+ data.substring(0,4);//formato a dd/mm/yyyy
        return dia 
        }else{
        return ''
        }  
    };

    export function alerta(that,text,color, time, text_posicion){

        if (!time){
            time = 2000
        }
        
        // alert(text);
        that.snackbar = true;
        that.snack_text= text;
        that.snack_color = color;
        that.snack_timeout = time;

        if ( (text?.includes('ERROR:')) || (text?.includes('error'))){ 
            that.snack_color = 'red';
        }
    };

    export function  getFormatCurrency(v,string){
        
        let r = null
        if (string=='S'){
            r = v.toLocaleString('pt-br',{ minimumFractionDigits: 2, maximumFractionDigits: 2 });//funciona pra string
        }else{
            r = Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(v); //funciona para numeros
        }

        return r
    };



    export function calcula_idade(data, campos){
        // console.log(data);

          if (data == '//'){ data = ''}

          var now = new Date();
          var today = new Date(now.getYear(),now.getMonth(),now.getDate());

          var yearNow = now.getYear();
          var monthNow = now.getMonth();
          var dateNow = now.getDate();
          var dob = new Date(data.substring(6,10),
              data.substring(3,5)-1,                    
              data.substring(0,2)                
              );

          var yearDob = dob.getYear();
          var monthDob = dob.getMonth();
          var dateDob = dob.getDate();
          var age = {};
          var yearAge = yearNow - yearDob;

          if (monthNow >= monthDob)
            var monthAge = monthNow - monthDob;
          else {
            yearAge--;
            var monthAge = 12 + monthNow -monthDob;
          }

          if (dateNow >= dateDob)
            var dateAge = dateNow - dateDob;
          else {
            monthAge--;
              var dateAge = 31 + dateNow - dateDob;

              if (monthAge < 0) {
                monthAge = 11;
                yearAge--;
              }
            }

          age = {
              years: yearAge,
              months: monthAge,
              days: dateAge
            };
        //   return age.years+' ano '+age.months+' mêses '+age.days+' dias'
        // return age;
        //   return age.years;


                //ADAPTACAO DSI
                if (data){
                  
                    let result = age

                    let r = ''
                    let mes = ' meses '
                    let ano = ' anos '

                    if (result.months == 1){
                        mes = ' mês '
                    }

                    if (result.years == 1){
                        ano = ' ano '
                    }
                    
                    //0 = oculta dias se nao for menor
                    if (campos == 0 ){

                        if (result.years < 1){
                            r = result.months+ mes +result.days+' dias'
                        }else {campos = 2}
                    }

                    if (campos == 1 ){
                        r = result.years+ ano
                    }else if (campos == 2 ){
                        r = result.years+ ano + result.months+mes
                    }else if (campos == 3 ){
                        r = result.years+ ano + result.months + mes + result.days+' dias' 
                    }

                    age['texto'] = r; //retorno um objeto 
                    return age
                    // return r
                }else{
                    return ''
                }
      };


      export function dif_datas(a,b){

        // var inicio     = new Date('2021-01-01 00:00:00')
        var AA     = new Date( a +' 00:00:00'); 
        var BB     = new Date( b +' 00:00:00'); 


        if (AA.getTime() === BB.getTime()){
            // console.log(AA + ' == '+ BB);
            // console.log('igual');
            return 0 //na validade
        }
        else if (AA.getTime() > BB.getTime()){
            // console.log('maior');
            // console.log((AA + ' >= '+ BB));
            return 1 //na validade
        }
        else{
            // console.log((AA + ' < '+ BB));
            // console.log('menor');
            return -1
        }
    };


    export async function diferenca_datas(d1, d2){

        const diffInMs   = new Date(d2) - new Date(d1)
        // alert(diffInDays)
        const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
        // console.log(diffInDays) // 38

        
        return diffInDays
    };

    

      export async function dias_do_mes(){
        
        var objData = new Date(),
        numAno = objData.getFullYear(),
        numMes = objData.getMonth()+1,
        numDias = new Date(numAno, numMes, 0).getDate();

        let de  = numAno+'-'+numMes+'-01'
        let ate = numAno+'-'+numMes+'-'+numDias

        let r = {'de': de, 'ate':ate }

        // console.log(r);

    
        return  r
      };


      export async function  somenteNumeros(string){
        if (string){
          var numsStr = string.replace(/[^0-9]/g,'');
          return (numsStr);
        }
        else{
            return string
        }
      };

      export async function  gerar_token(entra){
        var s = Math.random().toString(16).substr(2)
        if (entra){
          s = entra +'_'+ s
        }

        s = s.toUpperCase()
      //   console.log('gerar token:', s);

        return (s);
      };


      export async function gerar_id(
          tamanho ,
          entra  ,
          numeros 
      ) {
          let s = '';

          const chars = numeros
              ? '0123456789'
              : 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';

          for (let i = 0; i < tamanho; i++) {
              s += chars.charAt(
                  Math.floor(Math.random() * chars.length)
              );
          }

          if (entra) {
              // s = `${entra}_${s}`;
              s = `${entra}${s}`;
          }


          return s;
      };


      export async function consulta_cep(cep){

        if (cep?.length>=9){

          let link = "https://viacep.com.br/ws/"+cep+"/json/"
          const res = await axios.get(link);
        //   console.log(res.data);

          let retorno = {

            'ENDERECO': res.data.logradouro.toUpperCase(),
            'BAIRRO'  : res.data.bairro.toUpperCase(),
            'CIDADE'  : res.data.localidade.toUpperCase(),
            'UF'      : res.data.uf.toUpperCase()
          }

          return  retorno
        }

      }; 

      export async function  removerCampos(that, nome_items, camposARemover) {
        for (let i = 0; i < camposARemover?.length; i++) {
          const index = that.items_editaveis.findIndex(x => x.value === camposARemover[i]);
          if (index >= 0) { 
            that[nome_items].splice(index, 1);
          }
        }
      };

      export async function copiarParaClipboard(texto) {

        if (!navigator.clipboard) {
          // Clipboard API não disponível
          console.error('Acesso à área de transferência não disponível.');
          return false;
        }

        try {
          await navigator.clipboard.writeText(texto);
          //   console.log('Texto copiado para a área de transferência!');

          // this.alerta(`(${texto}) copiado para a área de transferência!`,'black')

          return true
          
        } catch (err) {
         //   console.error('Falha ao copiar o texto: ', err);
          return false
        }
      };


      export function geraIDdataHora() {
        let date = new Date();
    
        // Extrair componentes da data e hora
        let year = date.getFullYear().toString().slice(-2); // Dois últimos dígitos do ano
        let month = (date.getMonth() + 1).toString().padStart(2, '0'); // Mês começa em 0, por isso adicionamos 1
        let day = date.getDate().toString().padStart(2, '0'); 
        let hours = date.getHours().toString().padStart(2, '0');
        let minutes = date.getMinutes().toString().padStart(2, '0');
        let seconds = date.getSeconds().toString().padStart(2, '0');
    
        // Formatar a data e hora conforme solicitado
        let formattedDate = `${year}${month}${day}_${hours}${minutes}${seconds}`;
    
        return formattedDate;
      };

        // Função para criar um arquivo e baixar
      export  async function downloadText(textContent, fileName) {

        const blob = new Blob([textContent], { type: 'text/plain;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);

        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      };


      export async function processCsvFile(file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
      
          reader.onload = (e) => {
            const conteudo = e.target.result;
            console.log('conteudo (csv):', conteudo);
      
            // Processa o conteúdo do CSV
            const lines = conteudo.split('\n').map(line => line.trim());
            const headers = lines[0].split(';');
            const data = [];
      
            for (let i = 1; i < lines.length; i++) {
              if (lines[i]) { // Ignora linhas vazias
                const row = lines[i].split(';');
                const rowData = {};
                for (let j = 0; j < headers.length; j++) {
                  rowData[headers[j]] = row[j];
                }
                data.push(rowData);
              }
            }
      
            console.log('dados_importados (csv):', data);
            resolve(data); // Resolve a promessa com os dados processados
          };
      
          reader.onerror = (error) => {
            reject(error); // Rejeita a promessa em caso de erro
          };
      
          reader.readAsText(file);
        });
      }
      


      export async function processTxtFile(file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
      
          reader.onload = (e) => {
            const conteudo = e.target.result;
            console.log('conteudo (txt):', conteudo);
      
            try {
              const data = JSON.parse(conteudo);
              resolve(data); // Resolve a promessa com os dados processados
            } catch (error) {
              console.error('Erro ao parsear JSON:', error);
              reject(error); // Rejeita a promessa em caso de erro ao parsear JSON
            }
          };
      
          reader.onerror = (error) => {
            console.error('Erro ao ler o arquivo:', error);
            reject(error); // Rejeita a promessa em caso de erro na leitura do arquivo
          };
      
          reader.readAsText(file);
        });
      };


      export async function primeira_maiuscula(nome){

        nome = nome.toLowerCase().trim();  //passo tudo pra minuscula
        nome = nome.split(" ");//separo as palavras
        nome = nome[0];//pego o primeiro nome        
        nome = nome.charAt(0).toUpperCase() + nome.slice(1);//passo 1 letra maiuscula

        return nome
      };



export async function total_da_listaOK(that, item_name, items_somatorias, campo_valor,  campo_titulo , evitar_string){

        // percorro o array de objeto somando os valores pelo nome do campo..
        const resultado = {};
        // that.items_somatorias = []; // Limpa o array de somatórias
        that[items_somatorias] = []; // Limpa o array de somatórias
  
        if (campo_titulo) {
            let total  = 0;
            let saldo  = 0;
            let sum_qt = 0;
  
            that[item_name].forEach((item) => {
                let   campo = item[campo_titulo] || campo_titulo; // Se o campo não existir, usa o valor de campo_titulo
                // let   valor = parseFloat(strtofloat(item[campo_valor]));
                let   valor = parseFloat((item[campo_valor]));
                let   qt    = parseFloat((item['QT'])) || 0; //caso tenha campo QT ele soma o QT TOTAL USEI NO QT DE BOLETOS NO CFC FINANCEIRO.VUE

                // console.log('valor:', valor);
                
  
                // console.log('campo_titulo:', campo_titulo);

                
                
                if (campo_titulo == 'TIPO'){
                   if (campo == 'S'){
                      campo = 'SAIDA'
                      saldo -= parseFloat(valor);
                   }
                   else if (campo == 'E'){
                      campo = 'ENTRADA'
                      saldo += parseFloat(valor); 
                   }
                }
                // console.log('valor:', valor);
                // console.log('saldoo:', saldo);

  
                if (resultado[campo]) {
                    resultado[campo] += parseFloat(valor);
                } else {
                    resultado[campo] = parseFloat(valor);
                }
  
                total  += valor;
                sum_qt += qt;

                
            });
  
            resultado['TOTAL'] = parseFloat(total);

            if (saldo !==0){
               resultado['SALDO'] = parseFloat(saldo);
            }
            // console.log('saldo:', saldo);
            // console.log('resultado:', resultado);
            
            
  
            // Criar um novo array de objetos com os valores agrupados e a quantidade por campo
            const novoArrayDeObjetos = Object.keys(resultado).map((campo) => {
                return {
                    CAMPO: campo,
                    VALOR: resultado[campo].toFixed(2),
                    QT_TOTAL: sum_qt,
                    'QT': (campo !== 'TOTAL') ? that[item_name].filter(item => item[campo_titulo] === campo).length : that[item_name].length
                    // 'QT': campo !== 'TOTAL' ? this[item_name].filter(item => item[campo_titulo] === campo).length : ''
                };
            });
  
  
            // console.log(novoArrayDeObjetos);
            if (evitar_string){//faço um filtro tirando chaves que contenham alguma string que nao quero mostrar
              that[items_somatorias] = novoArrayDeObjetos.filter(elemento => !elemento.CAMPO.includes(evitar_string));
            }else{
              that[items_somatorias] = novoArrayDeObjetos;
            }
  
            
        }   

        return true
      };


export async function total_da_lista(
  that,
  item_name,
  items_somatorias,
  campo_valor,
  campo_titulo,
  evitar_string
) {

  const resultado = {};
  that[items_somatorias] = [];

  // 🔹 NORMALIZAÇÃO (NÃO MUDA COMPORTAMENTO)
  const campos_valor  = Array.isArray(campo_valor)  ? campo_valor  : [campo_valor];
  const campos_titulo = Array.isArray(campo_titulo) ? campo_titulo : [campo_titulo];

  if (campos_titulo.length) {

    let total  = 0;
    let saldo  = 0;
    let sum_qt = 0;

that[item_name].forEach((item, index_one) => {

  // alert(index_one)
  let qt = parseFloat(item['QT']) || 0;
  sum_qt += qt;

  let valorTotalItem = 0; // 🔹 valor único do item


  campos_valor.forEach((cv, idx) => {

    const ct = campos_titulo[idx] || campos_titulo[0];

    let campo = item[ct] || ct;
    let valor = strtofloat(item[cv]);

    // 🔹 define o valor do TOTAL apenas uma vez
    valorTotalItem = parseFloat(valor) || 0;
    // alert(campo+' = '+valor)

    if ((ct === 'TIPO')) {
      if (campo === 'S') {
        campo = 'SAIDA';
        saldo -= parseFloat(valor);
      } else if (campo === 'E') {
        campo = 'ENTRADA';
        saldo += parseFloat(valor);
      }
    }

    if (resultado[campo]) {
      resultado[campo] += parseFloat(valor);
    } else {
      resultado[campo] = parseFloat(valor);
    }
  });

  // ✅ TOTAL soma só UMA VEZ por item
  total += valorTotalItem;
});


    resultado['TOTAL'] = parseFloat(total);

    if (saldo !== 0) {
      resultado['SALDO'] = parseFloat(saldo);
    }

    // 🔹 SAÍDA IDÊNTICA À ORIGINAL
const novoArrayDeObjetos = Object.keys(resultado)
  .map((campo) => {
    return {
      CAMPO: campo,
      VALOR: resultado[campo].toFixed(2),
      QT_TOTAL: sum_qt,
      QT: (campo !== 'TOTAL')
        ? that[item_name].filter(item =>
            campos_titulo.some(ct => item[ct] === campo)
          ).length
        : that[item_name].length
    };
  })
  // 🔹 GARANTE TOTAL NO FINAL
  .sort((a, b) => {
    if (a.CAMPO === 'TOTAL') return 1;
    if (b.CAMPO === 'TOTAL') return -1;
    return 0;
  });


    if (evitar_string) {
      that[items_somatorias] = novoArrayDeObjetos.filter(
        elemento => !elemento.CAMPO.includes(evitar_string)
      );
    } else {
      that[items_somatorias] = novoArrayDeObjetos;
    }
  }

  return true;
};









      export  function gerarSQLInsert(tabela, objetos, com_codigo) {

        if (!objetos.length) {
          return "";
        }

        let IGNORAR = `CODIGO`

        if (com_codigo){
            IGNORAR = '-1'
        }

        // Filtra os objetos removendo os campos vazios, aqueles que começam com "x_" e o campo "CODIGO"
        let objetosFiltrados = objetos.map(objeto => {
          let novoObjeto = {};
          for (let chave in objeto) {
            if (
              objeto[chave] !== null &&
              objeto[chave] !== undefined &&
              objeto[chave] !== '' &&
              !chave.startsWith('x_') &&
              !chave.startsWith('xx_') &&
              chave !== IGNORAR
              // chave !== 'CODIGO'
            ) {
              novoObjeto[chave] = objeto[chave];
            }
          }
          return novoObjeto;
        });

        // Coleta todos os campos únicos presentes em algum objeto, exceto os que começam com "x_" e "CODIGO"
        let todosCampos = new Set();
        objetosFiltrados.forEach(objeto => {
          Object.keys(objeto).forEach(campo => {
            if ( (!campo.startsWith('x_')) && (!campo.startsWith('xx_')) && (!campo.startsWith('X_')) && (!campo.startsWith('XX_')) && (campo !== IGNORAR) ) {
              todosCampos.add(campo);
            }
          });
        });

        // Converte o set para array
        todosCampos = Array.from(todosCampos);

        // Monta os valores para o SQL, colocando NULL nos campos faltantes
        let valores = objetosFiltrados.map(objeto => {
          return `(${todosCampos.map(campo => {
            let valor = objeto[campo];
            if (valor === undefined) {
              return 'NULL';
            } else if (typeof valor === "string") {
              return `'${valor.replace(/'/g, "''")}'`;
            }
            return valor;
          }).join(", ")})`;
        });

        let sql = `INSERT INTO ${tabela} (${todosCampos.join(", ")}) VALUES ${valores.join(", ")};`;
        return sql;
      };


      function incMinutes(hora, intervalo){

        let inicio  = new Date('2023-01-01 '+hora);
        let corre   = new Date(inicio.getTime() + (intervalo * 60000)) 
        let final = new Date(corre).toLocaleTimeString('pt-Br',{ hour12: false, timeZone: 'America/Sao_Paulo' });//pego horario da data-hora

        if (final < hora){
            final = '23:59:00'
        }

        return final
    };     

    export async function setPrintStyle(orientation) {

      if (orientation == 'landscape'){
        // orientation = 'auto'
      }

      const printStyle = document.getElementById('printStyles');
      console.log('printStyle:', printStyle);

      if (printStyle) {
        printStyle.innerHTML = `@media print {@page {size: ${orientation} !important;}}`;
      } else {
        // Se por algum motivo o elemento não existir, ele será criado
        const style = document.createElement('style');
        style.id = 'printStyles';
        style.innerHTML = `@media print {@page {size: ${orientation} !important;}}`;
        document.head.appendChild(style);
      }

      // INSERIR ISSO NO INDEX.HTML
      // <style id="printStyles">
      //   @media print {
      //     @page {
      //       size: portrait;
      //     }
      //   }
      // </style>
    };


    export async function emojiToText(text) {

      // Verifica se o texto é um array
      if (Array.isArray(text)) {
        return text; // Retorna o array como está
      }

      // Regex para detectar todos os emojis (cobre mais blocos Unicode)
      const regex = /[\uD800-\uDFFF][\uDC00-\uDFFF]/g;

      // Substitui emojis por suas versões encodeURIComponent
      return text.replace(regex, (match) => encodeURIComponent(match));
    };
    

    export async function textToEmoji(text) {
      
      // Divide o texto em palavras usando espaços em branco como delimitadores
      const words = text.split(/\s+/);
    
      words.forEach((word) => {
        try {
          // Decodifica a palavra percent-encoded
          const decoded = decodeURIComponent(word);
    
          // Substitui a palavra codificada pela versão original no texto
          text = text.replace(word, decoded);
        } catch (e) {
          // Caso ocorra algum erro, ignora a palavra
        }
      });
    
      return text;
    };    


    export async function imprimir_conteudo(
      modeloRelatorio,
      obj_dados,
      headers,
      items,
      titulo,
      ocultarHeader,
      autoPrint,
      largura
    ) {
      let componente = "";
    
      // Define o tipo de componente com base no tipo de "items"
      if (Array.isArray(items)) {
        componente = "v-data-table";
        headers = JSON.stringify(headers);
        items = JSON.stringify(items);
      } else {
        componente = "v-textarea";
      }
    
      // Cria o objeto de dados para impressão
      const objDadosImpressao = {
        relatorios_show: true, // Permite ver o relatório
        qual: "AUTO",
        modelo_relatorio: modeloRelatorio,
        componente: componente,
        headers: headers,
        items: items,
        titulo: titulo,
        auto_print: autoPrint,
        ocultar_header: ocultarHeader,
        largura: largura,
        obj_dados: obj_dados,//passo aqui o objeto que sera usado la exemplo cadastro, clientes, etc..
      };
    
      // Salva o objeto na sessão para ser lido em relatorios.vue
      sessionStorage.setItem("obj_dados_impressao", JSON.stringify(objDadosImpressao));
    
      // Abre a página relatorios.vue
    
      // Obtém a URL atual
      const currentUrl = window.location.href;

      // Substitui o trecho após o hash (#) para apontar para "/relatorios"
      const urlRelatorios = currentUrl.replace(/#\/[^/]+$/, "#/relatorios");
  
      const novaJanela = window.open(urlRelatorios, "_blank");
      if (!novaJanela) {
        console.error("Não foi possível abrir a página de relatórios.");
      }
    
      // Após aberto, ajusta para não ser lido fora do contexto
      objDadosImpressao.relatorios_show = false;
      sessionStorage.setItem("obj_dados_impressao", JSON.stringify(objDadosImpressao));
    };    



    export async function exportVisibleToExcel(items, headers, nome) {
      // Filtra os headers visíveis
      const visibleHeaders = headers.filter((header) => header.visible !== false);
    
      const headerKeys = visibleHeaders.map((header) => header.value); // Campos presentes nos headers
      const headerCaptions = visibleHeaders.map((header) => header.text); // Títulos das colunas
    
      // Filtra os dados e converte somente os valores de moeda corretamente
      const filteredData = items.map((item) => {
        const filteredItem = {};
        headerKeys.forEach((key) => {
          let value = item[key];
    
          // Verifica se o valor é uma string no formato de moeda
          if (typeof value === "string" && (value.includes("R$") || /\d+,\d{2}$/.test(value))) {
            value = value.replace(/\s/g, ""); // Remove espaços em branco
            value = value.replace("R$", ""); // Remove o símbolo da moeda
            value = value.replace(/\./g, ""); // Remove separadores de milhar
            value = value.replace(",", "."); // Troca vírgula decimal por ponto
    
            // Converte para número apenas se ainda for um valor válido
            if (!isNaN(value) && value !== "" && value !== null) {
              value = Number(value);
            }
          }
    
          // Mantém strings comuns inalteradas
          filteredItem[key] = value;
        });
        return filteredItem;
      });
    
      // Cria a planilha baseada nos dados filtrados
      const ws = XLSX.utils.json_to_sheet(filteredData);
    
      // Adiciona os captions (títulos das colunas) na primeira linha
      XLSX.utils.sheet_add_aoa(ws, [headerCaptions], { origin: "A1" });
    
      // Define um novo arquivo de workbook (pasta de trabalho)
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Dados");
    
      // Salva o arquivo como Excel
      XLSX.writeFile(wb, nome + ".xlsx" || "tabela-dados.xlsx");
    };
    
    export async function somarCampo(array, campo, formatarMoeda = false) {
      // Simula um atraso (como se estivesse buscando dados de uma API)
      await new Promise(resolve => setTimeout(resolve, 500));

      // Calcula a soma dos valores
      const total = array.reduce((acc, item) => {
        let valor = item[campo];

        // Se o valor for uma string e contiver uma vírgula decimal, trata como moeda
        if (typeof valor === "string" && valor.includes(",")) {
          valor = valor.replace(/\./g, ""); // Remove separadores de milhar
          valor = valor.replace(",", ".");  // Substitui a vírgula decimal por ponto
        }

        // Converte para número e soma, garantindo que valores inválidos sejam tratados como 0
        return acc + (parseFloat(valor) || 0);
      }, 0);

      const count = array.length;

      // Se formatarMoeda for true, formata o total para moeda
      const totalFormatado = formatarMoeda
        ? total.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        : total;

      // Retorna o objeto com o total formatado ou não
      return { [campo]: totalFormatado, count: count };
    };


    export async function UltimoDiaDoMes(dataInicial) {
      const [ano, mes] = dataInicial.split("-").map(Number); // Quebra a string e converte para números
    
      // Pegamos o último dia do mês criando uma data com o próximo mês e o dia 0
      const ultimoDia = new Date(ano, mes, 0);
    
      // Converte a data para o formato YYYY-MM-DD no fuso horário do Brasil
      const opcoes = { year: "numeric", month: "2-digit", day: "2-digit", timeZone: "America/Sao_Paulo" };
      const rr = new Intl.DateTimeFormat("pt-BR", opcoes).format(ultimoDia);
    
      // Ajusta a saída para o formato esperado YYYY-MM-DD
      const [dia, mesFormatado, anoFormatado] = rr.split("/");
      const dataFormatada = `${anoFormatado}-${mesFormatado}-${dia}`;
    
      return dataFormatada;
    };


    export async function  esta_empresa(nome, nome2){
      // verifico o nome da empresa e se mostro ou nao algumas funcoes..exemplo Artmed
      nome   = nome.toLowerCase()
      let obj_dados_empresa = null
      
      try { obj_dados_empresa = JSON.parse(sessionStorage['obj_dados_empresa']) }
      catch (error) { console.log('esta_empresa erro:', error); }


      if (!obj_dados_empresa){
        return false
      }

      let empresa = obj_dados_empresa.NOME.toLowerCase()
      // alert(empresa)
      // alert(nome)

      if (empresa.includes(nome)){
        return true
      }else{

        if (empresa.includes(nome2)){
           return true
        }
        else{
          return false
        }
      } 

    };

  

    export  function formatDateToLong(data) {
        const opcoes = { day: '2-digit', month: 'long', year: 'numeric' }
        return new Date(data).toLocaleDateString('pt-BR', opcoes)
    };

    export async function abreviarDiaSemana(dataString) {
      // Converte "13/06/2025" para um objeto Date
      const [dia, mes, ano] = dataString.split('/');
      const data = new Date(`${ano}-${mes}-${dia}`); // Formato ISO

      const diasSemana = ["DOM", "SEG", "TER", "QUA", "QUI", "SEX", "SAB"];

      return diasSemana[data.getDay()];
    };



    export async function capturarIPeLocalizacao() {
      let resultado = {
        ip: null,
        localizacao: null,
        erro: null
      };

      try {
        // 1. Captura o IP público
        // const ipResponse = await fetch('https://api.ipify.org?format=json');//basica
        const ipResponse = await fetch('https://ipapi.co/json/');//com mais dados
        const ipData = await ipResponse.json();
        // resultado.ip = ipData.ip;
        resultado = ipData;
      } catch (err) {
        resultado.erro = 'Erro ao obter IP: ' + err.message;
        return resultado;
      }

      // 2. Captura a geolocalização
      return new Promise((resolve) => {
        if (!navigator.geolocation) {
          resultado.erro = 'Geolocalização não é suportada pelo navegador.';
          resolve(resultado);
        } else {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              resultado.localizacao = {
                latitude: position.coords.latitude,
                longitude: position.coords.longitude,
                precisao: position.coords.accuracy + ' metros'
              };
              resolve(resultado);
            },
            (error) => {
              resultado.erro = 'Erro ao obter localização: ' + error.message;
              resolve(resultado);
            }
          );
        }
      });
    };



    export async function validarCPF(cpf) {
      cpf = cpf.replace(/[^\d]+/g, ''); // remove tudo que não for número

      if (cpf.length !== 11) return false;

      // rejeita CPFs inválidos conhecidos (111.111.111-11, etc)
      if (/^(\d)\1{10}$/.test(cpf)) return false;

      let soma = 0;
      let resto;

      // primeiro dígito verificador
      for (let i = 1; i <= 9; i++) {
        soma += parseInt(cpf.substring(i - 1, i)) * (11 - i);
      }
      resto = (soma * 10) % 11;
      if (resto === 10 || resto === 11) resto = 0;
      if (resto !== parseInt(cpf.substring(9, 10))) return false;

      soma = 0;
      // segundo dígito verificador
      for (let i = 1; i <= 10; i++) {
        soma += parseInt(cpf.substring(i - 1, i)) * (12 - i);
      }
      resto = (soma * 10) % 11;
      if (resto === 10 || resto === 11) resto = 0;
      if (resto !== parseInt(cpf.substring(10, 11))) return false;

      return true;
    };
  

    export function formatDay(dayString) {
      const date = new Date(dayString);
      const dias = ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'];
      const diaNumero = date.getDate();
      const diaSemana = dias[date.getDay()];
      return `${diaNumero} ${diaSemana}`;
    };
    


     export async function calcular_juros(item, usar_tabela){
        
        let multa = sessionStorage['emp_multa']
        let juros = sessionStorage['emp_juros']
        let tolera = sessionStorage['emp_tolera']

        let m     = multa
        let j     = juros
        let j2    = 0
        let valor     = strtofloat(item.double_VALOR)
        let taxa      = strtofloat(item.double_TAXA)
        let juros_ja  = strtofloat(item.double_JUROS)
        let total = valor
        let total_juros = 0
        let string_juros = ''

        let today = get_data_hora('today')

        let dias = await diferenca_datas(item.DATA_VENCIMENTO, today)
        let dias_tolera = dias - tolera
        // console.log('dias:', dias);
        // console.log('dias_tolera:', dias_tolera);
        
        let multaArredondada = 0
        let jurosArredondado = 0

        if (usar_tabela) {
            // Calcula multa e juros diários com valor cheio
            const multa = (m * valor) / 100;
            const juros_dia = (j * valor) / 100;
            const juros_total = juros_dia * dias;

            // Arredonda só no final (como no SQL)
            multaArredondada = parseFloat(multa.toFixed(2));
            jurosArredondado = parseFloat(juros_total.toFixed(2));

            if (dias_tolera > 0) {
                total_juros = multaArredondada + jurosArredondado;

            } else {
                total_juros = 0;
            }
        }
        else{
          // senao ver se tem juros salvo no proprio campo da parcela
        //   if (juros_ja > 0){
          if (juros_ja != ''){
            total_juros = juros_ja
          }
        }

        // alert(total_juros)

        // 1º somas os juros
        total = parseFloat(valor) + parseFloat(total_juros) 


        // 2º depois subtrai as taxas
        if (taxa>0){
          total = parseFloat(total) - parseFloat(taxa)
        }

        
        total       = floatTostring(total)
        total_juros = floatTostring2(total_juros)

        

        string_juros = `Após vencimento, cobrar multa de ${multa}% = R$ ${multaArredondada} \n` +
                       `Após vencimento, cobrar juros de ${juros}% ao dia = R$ ${jurosArredondado}`


        let retorno = {
          dias_atrasado : dias,
          valor : valor,
          total : total,
          multa : m,
          juros : j2,
          total_juros: total_juros || '0,00',
          string_juros: string_juros
        }

        return retorno

      };



      export function separarOrgaoUF(texto) {
        if (!texto) return { ORGAO: '', UF: '' };

        // Normaliza: tira espaços duplos e troca '/' por espaço
        texto = texto.trim().replace(/\s*\/\s*/, ' ').replace(/\s+/g, ' ');

        let ORGAO = '';
        let UF = '';

        if (texto.includes(' ')) {
          // Caso com espaço (ex: "SESP PR")
          const partes = texto.split(' ');
          UF = partes.pop().toUpperCase();
          ORGAO = partes.join(' ').trim().toUpperCase();
        } else if (texto.length > 2) {
          // Caso tudo junto (ex: "SJSRS" → "SJS" + "RS")
          UF = texto.slice(-2).toUpperCase();
          ORGAO = texto.slice(0, -2).toUpperCase();
        } else {
          // Caso só o UF
          UF = texto.toUpperCase();
        }

        return { ORGAO, UF };
      };



      export async function salvarComoImagem(id, name, qualidade, escala) {
        const elemento = document.getElementById(id);
        
        escala = escala || 2
        // alert(escala)
        // ⬇️ Diminui o scale se quiser reduzir ainda mais Quanto menor, menor a resolução e o tamanho do arquivo. (padrão: 2)
        // const canvas = await html2canvas(elemento, { scale: (qualidade) ? 2 : 1.5 , useCORS: true }); //1.5 2
        // const canvas = await html2canvas(elemento, { scale: 2 , useCORS: true }); //1.5 2
        const canvas = await html2canvas(elemento, { scale: escala , useCORS: true }); //1.5 2

        let imgData

        if (qualidade){
            imgData = canvas.toDataURL("image/png");
        }
        else{
           // ⬇️ Usa JPEG e ajusta a qualidade (0.7 = 70%)  parâmetro controla a qualidade (de 0 a 1)
            // imgData = canvas.toDataURL("image/jpeg", 0.7);//0.5
            imgData = canvas.toDataURL("image/jpeg", 0.3);//0.5
        }



        const link = document.createElement("a");
        link.download = `${name || "imagemDSi"}.png`;

        if (name!='NAO_SALVAR'){
           link.href = imgData;
        }
        link.click();

        return imgData; // ← retorna a imagem em base64
      };

      export async function compartilharComoImagem(id, name) {


          const elemento = document.getElementById(id);
          const canvas   = await html2canvas(elemento, { scale: 2, useCORS: true });


          
          let parImpar = diaParOuImpar()
          // cria duas pasta assim eu apago a que nao for do dia
          let pasta = 'temp_' + parImpar

          // ESTA PASTA EU APAGO TODA VEZ
          // QUE O USUARIO FAZ LOGIN
          // A ROTINA ESTA EM login.vue limpar_pasta()

          // ⬇️ converte canvas para blob
          const imageBlob = await new Promise(resolve => {
              canvas.toBlob(resolve,  'image/png');
          });


          const file_name = `${name || 'imagemDSi'}.png`
          let meu_retorno = await upload_arquivo(imageBlob, file_name, pasta);
          
          


          const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent)
          // const isMobile = ismobile()
          // const isMobile = isShare

          if (isMobile && navigator.share && (confirm(`Compartilhar Arquivo?`))){

              // if (confirm(`Compartilhar Arquivo?`)){
                  try {
                      const file = new File( [imageBlob], file_name, { type: 'image/png' })
                      await navigator.share({ files: [file] })
                  } catch (e) { console.log(e)}
              // }
          }
          else{

              // ⬇️ baixa a imagem no computador
              const url = URL.createObjectURL(imageBlob)

              const a = document.createElement('a')
              a.href = url
              a.download = file_name
              document.body.appendChild(a)
              a.click()
              document.body.removeChild(a)

              URL.revokeObjectURL(url)

              // alert('Compartilhamento somente pelo Celular!')
          }

          return meu_retorno
      };


      export async function upload_arquivo( imageBlob, file_name, pasta) {

          // console.log('imageBlob:', imageBlob);        
          let rr = "";
          let url = sessionStorage['url']

          const formData = new FormData();

          formData.append('my_file', imageBlob, file_name);
          formData.append('pasta', pasta);

          try {

              const response = await axios.post(url + './upload.php', formData,{headers: {'Content-Type':'multipart/form-data',},});
              rr = response.data;
              console.log("Resposta do servidor:",rr);

              if (rr.message && rr.message.includes('sucesso')){
                return rr
              } 
              else {return rr}

          } catch (error) {
              console.error('Erro ao enviar requisição:',error);
              return false
          }
      };

      export async function salvarComoPDF(id, name, qualidade) {

        // qualidade = false

        const elemento = document.getElementById(id);

        // Captura o elemento como imagem
        const canvas = await html2canvas(elemento, { scale: (qualidade) ? 2 : 1.5, useCORS: true });
        // const imgData = canvas.toDataURL("image/png");
        let imgData

        if (qualidade){
            imgData = canvas.toDataURL("image/png");
        }
        else{
          // ⬇️ Usa JPEG e ajusta a qualidade (0.7 = 70%)  parâmetro controla a qualidade (de 0 a 1)
            imgData = canvas.toDataURL("image/jpeg", 0.7);//0.5
        }


        // Cria o PDF com o mesmo tamanho da imagem (em mm)
        const pdf = new jsPDF({
          orientation: "p",
          unit: "px",
          format: [canvas.width, canvas.height],
          compress: true //Gere o PDF com compressão ZIP 
        });

        // Adiciona a imagem no PDF e salva
        pdf.addImage(imgData, "PNG", 0, 0, canvas.width, canvas.height);
        pdf.save(`${name||'arquivoDSi'}.pdf`);


        // Cria e abre em nova aba
        const blob = pdf.output("blob");
        const url = URL.createObjectURL(blob);
        // window.open(url, "_blank");

        return url;

      };


      export async function imagemParaPDF(imgUrls = [], name = "arquivo") {
        
        // da pra deixar cada  imagem numa pagina separada, basta pegar essa funcao e jogar no chat

        if (!Array.isArray(imgUrls) || imgUrls.length === 0) {
          throw new Error("Envie uma lista de URLs de imagens.");
        }

        // Carregar todas as imagens
        const imagens = await Promise.all(
          imgUrls.map(url => {
            return new Promise((resolve) => {
              const img = new Image();
              img.crossOrigin = "anonymous";
              img.src = url;
              img.onload = () => resolve(img);
            });
          })
        );

        // Descobrir largura final = maior largura entre as imagens
        const larguraFinal = Math.max(...imagens.map(i => i.width));

        // Altura final = soma das alturas
        const alturaFinal = imagens.reduce((acc, img) => acc + img.height, 0);

        // Cria o PDF com a largura e altura total
        const pdf = new jsPDF({
          orientation: larguraFinal > alturaFinal ? "l" : "p",
          unit: "px",
          format: [larguraFinal, alturaFinal],
          compress: true
        });

        // Posição Y inicial
        let posY = 0;

        imagens.forEach(img => {
          // Centralizar horizontalmente (opcional – deixe 0 se não quiser)
          const posX = (larguraFinal - img.width) / 2;

          pdf.addImage(img, "JPEG", posX, posY, img.width, img.height);

          // Move o Y para baixo da próxima imagem
          posY += img.height;
        });

        // Gerar arquivo
        const blob = pdf.output("blob");
        const url = URL.createObjectURL(blob);
        // window.open(url, "_blank");

        return url;
      };

      export async function setMarginP_CSS(size) {
        const printStyle = document.getElementById('printStyles');
        const cssRule = `
          .v-application p {
              margin-bottom: ${size}px !important;
          }
        `;

        if (printStyle) {
          printStyle.innerHTML = cssRule;
        } else {
          const style = document.createElement('style');
          style.id = 'printMarginTop';
          style.innerHTML = cssRule;
          document.head.appendChild(style);
        }
      };




      export async function url_download_server(acao, img, file_name){

        let sql = ``
        let url  = sessionStorage['url']
        
        let path_base  =  'cfc_'+(sessionStorage['lg:IDE']) 
        file_name = path_base +'/'+ file_name  


        const res = await axios.post(url+'url_download.php', {
            acao      :  acao,
            file_name :  file_name,
            img       :  img
        })

        // console.log('retorno:', res.data);

        if (res.data.resultado){

            let url_retorno = res.data.url_retorno
            url_retorno = url + url_retorno            
        }
        else{
            console.log('ops');
        }

        return res.data

      };


      export async function getKEYsql(){
        //USADO PARA GERAR UMA CHAVE POIS QUANDO FAZ UM INSERT ELE NAO TEM UM CODIGO.. ENTAO USA O KEY PARA REFERENCIAR O REGISTRO

        // console.log('update_values');
        let a = new Date().toLocaleDateString('pt-Br',{ datestyle: 'short', hour12: false, timeZone: 'America/Sao_Paulo' });  
        // console.log('hoje = '+ a);
        let hoje = a;

        // a = new Date().toLocaleTimeString('pt-Br',{ timeStyle: 'short', hour12: false, timeZone: 'America/Sao_Paulo' });
        a = new Date().toLocaleTimeString('pt-Br',{ hour12: false, timeZone: 'America/Sao_Paulo' });
        // console.log('hora = '+ a);
        let hora = a;

        a = hoje + '_'+ hora;
        // console.log('data_hora = '+ a);
        return a;

    };


    export async function codificar_token_45(entra){

       entra = entra * 1 //torno numerico
       entra = entra * 777888999

       return entra
    }
    
    export async function decodificar_token_45(entra){

       entra = entra * 1 //torno numerico
       entra = entra / 777888999

       return entra
    }


    export async function apagar_arquivo(arquivo){
      
      // console.log('arquivo:', arquivo);

      // alert(2)
      // return false
      
      url = sessionStorage['url']

      if (!url){
        console.log('url não definida!');
        return false
      }
      

      if (!arquivo){
        console.log('arquivo não definida!');
        return false 
      }



      let via_ftp = false
      
      let rrftp = []

      try {
        const isFtp = arquivo.includes('uploads');
        const campo = isFtp ? 'arquivo_ftp' : 'arquivo';


        if (isFtp){
          rrftp = await config_ftp_45()
          if (rrftp.FTP_ATIVO=='S'){
              via_ftp = true
          }
        }


        const bodyFormData = new FormData();
        bodyFormData.append(campo, arquivo);


        if (via_ftp){
            bodyFormData.append('ftp_host'     , rrftp.FTP_URL);
            bodyFormData.append('ftp_user'     , rrftp.FTP_USER);
            bodyFormData.append('ftp_pass'     , rrftp.FTP_PASS);
            bodyFormData.append('ftp_port'     , rrftp.FTP_PORT);
            bodyFormData.append('url_files'    , rrftp.URL_FILES);
        }
        

        const header = { headers: {'Content-Type': 'multipart/form-data'}}
        const response = await axios.post(url + 'limpa_pasta.php', bodyFormData, header);

        const rr = response.data;
        console.log("Resposta do servidor:", rr);

      } catch (error) {
        console.error('Erro ao enviar requisição para o servidor:', error);
        return false;
      }
      

    };


    export async function apagar_pasta(pasta){
      
      url = sessionStorage['url']

      if (!url){
        console.log('url não definida!');
        return false
      }
      

      if (!pasta){
        console.log('Pasta não definida!');
        return false 
      }


      try {
            
            // pasta = sessionStorage['LSfolder']
            // let parImpar =  diaParOuImpar()
            // pasta = pasta+'/print_lab_'+parImpar  //cria duas pasta assim eu apago a que nao for do dia

            let rr = ""; // Variável para armazenar a resposta do servidor

            // Criando o objeto FormData
            const formData = new FormData();
            formData.append('pasta', pasta);

            // console.log(url+'limpa_pasta.php');
            const response = await axios.post(url+'limpa_pasta.php', formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            });
            
            rr = response.data;
            console.log("Resposta do servidor:", rr);


          // Aqui você pode fazer outras operações com a rr
        } catch (error) {
          console.error('Erro ao enviar requisição para o servidor:', error);
          return false
        }
    };



    export async function formatarTelefoneWhatsapp(valor) {
      if (!valor) return '';

      // remove tudo que não for número
      let numeros = valor.replace(/\D/g, '');

      // remove código do país (55)
      if (numeros.startsWith('55')) {
        numeros = numeros.slice(2);
      }

      const ddd = numeros.slice(0, 2);
      const telefone = numeros.slice(2);

      // formato: 46-3262-2611 ou 46-9xxxx-xxxx
      if (telefone.length === 8) {
        return `(${ddd}) ${telefone.slice(0,4)}-${telefone.slice(4)}`;
      }

      if (telefone.length === 9) {
        return `(${ddd}) ${telefone.slice(0,5)}-${telefone.slice(5)}`;
      }

      // fallback simples
      return `${ddd}-${telefone}`;
    };
    

    export async function extrairTextoHTML(html) {
      const div = document.createElement('div');
      div.innerHTML = html;
      return div.innerText.trim();
    };



    export function se_DI_maior_DF(dataA, dataB) {
      if (!dataA || !dataB) return false;

      const [anoA, mesA, diaA] = dataA.split('-').map(Number);
      const [anoB, mesB, diaB] = dataB.split('-').map(Number);

      const A = new Date(anoA, mesA - 1, diaA);
      const B = new Date(anoB, mesB - 1, diaB);

      A.setHours(0, 0, 0, 0);
      B.setHours(0, 0, 0, 0);

      return A > B;
    };



    function formatarTamanho(bytes) {
      const mb = bytes / (1024 * 1024);
      return mb.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }) + ' MB';
    };


    export async function config_ftp_45(){
        // BUSCA CONFIGURACOES DO FTP NO 45
        const { crud_abrir_tabela_canal } = await import('./DSi_login');

        let sql = `select URL_FILES, FTP_URL, FTP_USER, FTP_PASS, FTP_PORT, FTP_ATIVO   from empresa`
        let rr = await crud_abrir_tabela_canal(sql)
        rr = rr[0] || false
        // console.log('rr:', rr);
        if (rr.FTP_ATIVO=='S'){
            return rr
        }
        else{
          return false
        }
    };




    export async function upload_file(that, file, pasta, nome){


      let via_ftp = false

      let rrftp = await config_ftp_45()
      if (rrftp.FTP_ATIVO=='S'){
          via_ftp = true
      }


    

      if (!file){
        return false
      }

      let obj_dados_empresa 
      try { obj_dados_empresa = JSON.parse(sessionStorage['obj_dados_empresa']) }
      catch (error) { return false }

      // const tamanhoMaximo = 5 * 1024 * 1024; // 5 MB
      // const tamanhoMaximo = 1.5 * 1024 * 1024; // 1 MB
      // const tamanhoMaximo = 1.5 * 1024 * 1024; // 1.5 MB
      const tamanhoMaximo = 2 * 1024 * 1024; // 2 MB

      if (file.size > tamanhoMaximo) {
        alert(`Arquivo muito grande (${formatarTamanho(file.size)}). Máximo permitido: 1MB.`);
        return false;
      }

      let ide_cliente   = obj_dados_empresa.IDE * 1
      ide_cliente       = ide_cliente * 777888999 //cripto

      // let pasta_cliente = 'mc_'+ sessionStorage['LSid'];antes
      // let pasta_cliente = 'cfc_'+ ide_cliente;
      let pasta_cliente = ide_cliente;
      var url_local     = sessionStorage['url']

      //update refresh image
      // let img_get = URL.createObjectURL(file);

      var bodyFormData = new FormData();
      bodyFormData.append('pasta'       , pasta_cliente + pasta);
      bodyFormData.append('nome_arquivo', nome);
      bodyFormData.append('userfile'    , file);
      bodyFormData.append('via_ftp'     , via_ftp);

      if (via_ftp){
          bodyFormData.append('ftp_host'     , rrftp.FTP_URL);
          bodyFormData.append('ftp_user'     , rrftp.FTP_USER);
          bodyFormData.append('ftp_pass'     , rrftp.FTP_PASS);
          bodyFormData.append('ftp_port'     , rrftp.FTP_PORT);
          bodyFormData.append('url_files'    , rrftp.URL_FILES);
      }
      
      // console.log('bodyFormData:', bodyFormData);

      //isso daqui server para ser lido com o $_POST no php 
      const header = { headers: {'Content-Type': 'multipart/form-data'}}

      const res = await axios.post(url_local+'upFile.php', bodyFormData, header)
      //upFile.php >> ftp.php

      let retorno = {
        status :'',
        msg    :'',
        url    : '',
        res    : ''
      }

      

      if (res.data.status == 'OK'){

          retorno.status = 'OK'
          retorno.msg    = 'Atualizado'
          retorno.res    = res.data

          // 🔥 USA O PATH CORRETO DO PHP (NUNCA MONTA MANUAL)
          // retorno.url = res.data.path
          retorno.url = res.data.url

      }else{
          retorno.status = 'OPS'
          retorno.msg    = res.data.msg || 'Ops'
          retorno.res    = res.data
      }

      try{
        that.selectedFile = null
      }catch(e){}




      // talvez no ftp isso dea ser desativado
      if ((url_local == '/api/') && (!via_ftp)){
        retorno.url =   '/'+ retorno.url
      }

      return retorno  

    };


    export async function gen_id_file(start) {

      const d = new Date();

      const ano = d.getFullYear();
      const mes = String(d.getMonth() + 1).padStart(2, '0');
      const dia = String(d.getDate()).padStart(2, '0');

      const hora = String(d.getHours()).padStart(2, '0');
      const min = String(d.getMinutes()).padStart(2, '0');
      const seg = String(d.getSeconds()).padStart(2, '0');

      let id = `${ano}${mes}${dia}_${hora}${min}${seg}`;

      if (start) {
        id = `${start}_${id}`;
      }

      return id;
    };


    export async function parseNumeroBR(texto) {
      if (typeof texto !== 'string') return null;

      texto = texto.trim();

      // remove espaços
      texto = texto.replace(/\s/g, '');

      // caso tenha vírgula, assume formato BR
      if (texto.includes(',')) {
        texto = texto.replace(/\./g, '');   // remove milhar
        texto = texto.replace(',', '.');    // troca decimal
      }

      const numero = Number(texto);

      return isNaN(numero) ? null : numero;
    };

    export function saudacao(texto) {
      const hora = new Date().getHours()

      let sss = ''
      if (hora >= 5 && hora < 12) {
        sss = 'Olá bom dia, '
      } else if (hora >= 12 && hora < 18) {
        sss = 'Olá boa tarde, '
      } else {
        sss = 'Olá boa noite, '
      }

      return sss + (texto || '')
    };


    export function mostrar_tipo_cliente() {


        let tipo_cliente_cache = null
        console.log('mostrar_tipo_cliente:')

        try {

            // lê da session apenas na primeira vez
            if (tipo_cliente_cache === null) {

                tipo_cliente_cache =
                    JSON.parse(sessionStorage['obj_user'])?.TIPO_CLIENTE || []

            }

            if (tipo_cliente_cache.includes('CFC')){
               return 'CFC'
            }else{
              return tipo_cliente_cache
            }

        } catch (error) {

            console.log('OPSSS:', error)
            return 'OPS'

        }

    };

    export function mostrar_tipo_clienteOK(tipo) {

        // console.log('mostrar_tipo_cliente:', tipo)

        try {

            // lê da session apenas na primeira vez
            if (tipo_cliente_cache === null) {

                tipo_cliente_cache =
                    JSON.parse(sessionStorage['obj_user'])?.TIPO_CLIENTE || []

            }

            return tipo_cliente_cache.includes(tipo)

        } catch (error) {

            console.log('OPSSS:', error)
            return false

        }

    };



      export function diaParOuImpar(data, reverso){
        
          //reverso = quando quero que ele volte o contrario do que seria o padrao
          if (!data){
             data = new Date(); // Ajuste para a data que deseja verificar  
          }

          //pega o dia do mes
          const diaDaSemana = data.getDate();

          let retorno 

          // Verifica se o número do dia é par ou ímpar
          if (diaDaSemana % 2 === 0) {
            // dia par
            if (reverso){ retorno = 1} else { retorno = 2}

          } else {
            // dia imipar
            if (reverso){ retorno = 2} else { retorno = 1}
          }

          return retorno
        
      };


      export async function diferencaMeses(data1, data2) {
        const d1 = new Date(data1);
        const d2 = new Date(data2);

        let meses = (d2.getFullYear() - d1.getFullYear()) * 12;
        meses += d2.getMonth() - d1.getMonth();

        return meses;
      };


export default {
    ismobile,
    maps,
    send_whats,
    moeda,
    allUpper,
    firstUpper,
    define_data_hora,
    incDay,
    incMonth,
    incMinutes,
    strtofloat,
    floatTostring,
    floatTostring2,
    getFormatDate,
    alerta,
    getFormatCurrency,
    calcula_idade,
    dif_datas,
    diferenca_datas,
    dias_do_mes,
    gerar_token,
    somenteNumeros,
    geraIDdataHora,
    get_quem_alterou,
    primeira_maiuscula,
    imprimir_conteudo,
    UltimoDiaDoMes,
    esta_empresa,
    formatDateToLong,
    validarCPF,
    calcular_juros

};


